import * as React from 'react';
import styles from './HeaderBlock.styl';
const HeaderBlock = ({ textHeader, headerStyle }) => (React.createElement("div", { className: `${styles.textHeader} ${headerStyle}` }, textHeader));
export default HeaderBlock;
